import React, { Component } from 'react'
import { IFilterItemProps, OperatorList, FilterItemInputRenderType } from './models'
import { FieldTypeEnum } from '../enums/field.type.enum';



interface IState {
    id: string,
    op: string,
    value: string
}
export class FilterItemFieldType extends Component<IFilterItemProps, IState> {
    constructor(props) {
        super(props);
    }

    oprators = OperatorList.fieldType;
    inputRenderType: any = FilterItemInputRenderType.NoBox;

    selectedOptionValue = this.oprators[0].operator;
    selectedValue = '';

    handleDropDownChange = (event: any) => {
        let selectedObject = this.oprators.find(x => x.name == event.target.value);
        this.selectedOptionValue = selectedObject != null ? selectedObject.operator : "";
        this.inputRenderType = selectedObject?.renderType;
        if (this.selectedOptionValue == 'is' || this.selectedOptionValue == 'isnot') {
            this.selectedValue = 'null';
        }
        if (this.selectedOptionValue === 'eq') {
            switch (selectedObject?.name) {
                case FieldTypeEnum.currency:
                    this.selectedValue = FieldTypeEnum.currency
                    break;
                    case FieldTypeEnum.date:
                        this.selectedValue = FieldTypeEnum.date
                        break;
                        case FieldTypeEnum.float:
                        this.selectedValue = FieldTypeEnum.float
                        break;
                        case FieldTypeEnum.integer:
                        this.selectedValue = FieldTypeEnum.integer
                        break;
                        case FieldTypeEnum.raw:
                        this.selectedValue = FieldTypeEnum.raw
                        break;
                        case FieldTypeEnum.string:
                        this.selectedValue = FieldTypeEnum.string
                        break;
                        case FieldTypeEnum.text:
                        this.selectedValue = FieldTypeEnum.text
                        break;
                        case FieldTypeEnum.time:
                        this.selectedValue = FieldTypeEnum.time
                        break;
                        case FieldTypeEnum.url:
                        this.selectedValue = FieldTypeEnum.url
                        break;
                        case FieldTypeEnum.big_integer:
                        this.selectedValue = FieldTypeEnum.big_integer
                        break;
                        case FieldTypeEnum.boolean:
                        this.selectedValue = FieldTypeEnum.boolean
                        break;
               
            }

        }
        this.brodCastValue();        
    }

    brodCastValue = () => {
        this.setState({ id: this.props.column.columnName, op: this.selectedOptionValue, value: this.selectedValue });
        this.props.onValueChange({ column: this.props.column.columnName, op: this.selectedOptionValue, value: this.selectedValue });
    }
    render() {
        return (
            <div className="form-group mb-3">
                <label>{this.props.column.displayText}</label>
                <div className="row">
                    <div className="col-5">
                        <select className="form-control form-control-sm mb-1" name={this.props.column.columnName} onChange={this.handleDropDownChange}>
                            {this.oprators.map((num, index) => {
                                return (
                                    <option key={index} value={num.name} className='form-control'>{num.name}</option>
                                );
                            })}

                        </select>
                    </div>
                </div>
            </div>
        )
    }
}
